import React, { useState, useEffect } from "react";
import axios from "axios";
import axiosInstance, { weburl } from "../../../axiosInstance";
import Swal from "sweetalert2"; // Import SweetAlert2
import withReactContent from "sweetalert2-react-content"; // Import React components for SweetAlert2

import Sidebar from "../../components/Sidebar";
import Navbar from "../../components/Navbar";
import LoadingTable from "../../components/LoadingTable";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import getDecryptData from "../../../helpers/getDecryptData";

const MySwal = withReactContent(Swal); // Create a SweetAlert2 instance with React components

function AllUser({
  pageTitle = "All Users",
  defaultType = "",
  defaultEmpType = "",
  hideTypeFilter = false,
  hideEmployeeTypeFilter = false,
}) {
  
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

    const [AllState, setState] = useState([]);
    const [Nurse, setAllNurse] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
    const [TotalUser, setTotalUser] = useState(null);

  const [limit, setlimit] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
    const [Active, setActive] = useState('all');
 
   const [filteredCities, setFilteredCities] = useState([]);

   const [ChangeRest, setChangeRest] = useState(false);


       const fetchNurseData = async () => {
    
       try {
         const response = await axiosInstance.get("/get-all-nurse-department");
         console.log("response.data.Department,", response.data);
         setAllNurse(response.data.Department || []);
       } catch (error) {
         console.error("Error fetching data:", error);
       } finally {
        }
     };
   

     const AllZoneData = async () => {
        console.log("response.data start");
   
       try {
         const response = await axiosInstance.get("/get-all-zones");
          setState(response.data.Zones);
       } catch (error) {
         console.error("Error fetching data:", error);
       }  
     };
   
   


  const fetchData = async () => {
    const decryptdatajson = await getDecryptData();
    const id = decryptdatajson?._id;
    const type = decryptdatajson?.type;
    const empType = decryptdatajson?.empType;

    let userId = '';
    if(type !== 0){
      userId = id
    }
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/admin/all-user?page=${currentPage}&limit=${limit}&search=${searchTerm}&empType=${inputs.empType}&type=${inputs.type}&active=${Active}&name=${inputs.name}&phone=${inputs.phone}&pincode=${inputs.pincode}&state=${inputs.state}&city=${inputs.city}&location=${inputs.location}&nurse=${inputs.nurse}&userId=${userId}`
      );
      setData(response.data.users);
      setCurrentPage(response.data.currentPage);
      setTotalPages(response.data.totalPages);
      setTotalUser(response.data.totalUsers);
 
      console.log(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    setData([]);

    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage, limit,Active,ChangeRest]);

    useEffect(() => {
    setCurrentPage(1);
  }, [limit]);

    useEffect(() => {
    AllZoneData();
    fetchNurseData();
  }, []);

  

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  // Function to handle delete
  const handleDelete = (categoryId) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this data!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
      customClass: {
        popup: "custom-swal-popup", // Add a class to the entire dialog
        confirmButton: "btn-danger", // Add a class to the confirm button
      },
    }).then((result) => {
      if (result.isConfirmed) {
        axiosInstance
          .delete(`/admin/delete-user/${categoryId}`)
          .then(() => {
            // Refresh the data or update the state after successful deletion
            fetchData();
            toast.success("Deleting Rating success!");
          })
          .catch((error) => {
            console.error("Error deleting data:", error);
            toast.error("Error deleting data");
          });
      }
    });
  };

  const handleStatusChange = (StatusId) => async (event) => {
    const newStatus = event.target.value;
    setLoading(true);

    try {
      await axiosInstance.put(`/admin/update-user/${StatusId}`, {
        status: newStatus,
      });
      setLoading(false);
      fetchData(currentPage);
      toast.success("Status Updated success!");
    } catch (error) {
      console.error("Error updating rating status:", error);
      setLoading(false);
    }
  };

  const [inputs, setInputs] = useState({
    name: '',
    phone : '',
    pincode: '',
     location: '',
      state: '',
     city: '',
     type: defaultType,
     empType : defaultEmpType,  
     nurse : "",
  });
  //handle input change
  const handleChange = (e) => {
      const { name, value, type, checked, files } = e.target;

          let newValue;
      newValue = value;

          if (name === "state") {
      const selectedState = AllState.find((state) => state._id === newValue);
      if (selectedState) {
        setFilteredCities(selectedState.cities);
        console.log('selectedState.cities',selectedState.cities)
        setInputs((prevData) => ({
          ...prevData,
          statename: selectedState.name,
          city: "",
        }));
      }
      console.log("selectedState", selectedState, newValue, data);
    } 

      if (name === "nurse") {
      const value = e.target.value;
    
      const selected = [...(Array.isArray(inputs.nurse) ? inputs.nurse : [])];
    
      if (!selected.includes(value)) {
        selected.push(value);
    
        setInputs((prev) => ({
          ...prev,
          nurse: selected,
        }));
    
        console.log("selected", selected); // ✅ shows correct array
      }
      return null;
    }

     setInputs((prevData) => ({
          ...prevData,
          [name]:
              type === "checkbox" ? checked : type === "file" ? files[0] : value,
      }));
    
   
  };

  const handleVerifyChange = (StatusId) => async (event) => {
    const newStatus = event.target.value;
    setLoading(true);

    try {
      await axiosInstance.put(`/admin/update-user-verify/${StatusId}`, {
        status: newStatus,
      });
      setLoading(false);
      fetchData(currentPage);
      toast.success("Verification Updated success!");
    } catch (error) {
      console.error("Error updating rating status:", error);
      setLoading(false);
    }
  };

  const inputRef = React.createRef();

  const handleSearchInputChange = (e) => {
    setCurrentPage(1);
    setTotalPages(1);
    setSearchTerm(e.target.value);
  };

  const handleSearch = () => {
    fetchData(currentPage);
  };

    const handleReset = () => {
 setActive('all');
setlimit(10);
setCurrentPage(1)
  
 setInputs((prevData) => ({
          ...prevData,
    name: '',
    phone : '',
    pincode: '',
     location: '',
      state: '',
     city: '',
     type: defaultType,
     empType: defaultEmpType,
        nurse : "",
      })); 
 if(ChangeRest){
    setChangeRest(false);
  }else{
    setChangeRest(true);
  }
  };

      const removeNurse = (data) => {
    setInputs((prev) => ({
      ...prev,
      nurse: prev.nurse.filter((c) => c !== data),
    }));
  };


  return (
    <>
      <Sidebar />
      <main className="content">
        <Navbar />
        <div className="py-4">
          <div className="d-flex justify-content-between w-100 flex-wrap">
            <div className="mb-3 mb-lg-0">
              <h1 className="h4"> {pageTitle} 
                {TotalUser && <>
              ({defaultType ? TotalUser : TotalUser -1})</>} </h1>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="table-responsive py-4 mb-4" >
            {loading ? (
              <LoadingTable />
            ) : (
              <>
                <div className="datatable-top" >
                  <div className="datatable-dropdown">
                    <label>
                      <select
                        className="datatable-selector"
                        value={limit}
                        onChange={(e) => {
                          setlimit(parseInt(e.target.value, 10));
                          setCurrentPage(1); // Reset current page to 1 when the limit changes
                        }}
                      >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={15}>15</option>
                        <option value={20}>20</option>
                        <option value={25}>25</option>
                      </select>{" "}
                      entries per page
                    </label>
                  </div>

                   <div className="datatable-dropdown">

                    <div class="dropdown">
  <button class="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
    Filter <i className="ri-equalizer-fill" />
  </button>
  <ul class="dropdown-menu p-2" style={{minWidth:300}}>

    
                  {!hideTypeFilter && <ul className="customradio input-group two-grid  mb-4 px-0 mx-0">
                    <li>
                      <input
                        type="radio"
                        name="type"
                        onChange={handleChange}
                        value="1"
                        checked={inputs.type === "1"}
                      />
                      <label className="p-1">Employee</label>
                    </li>
                    <li>
                      <input
                        type="radio"
                        name="type"
                        onChange={handleChange}
                        value="2"
                        checked={inputs.type === "2"}
                      />
                      <label className="p-1">User</label>
                    </li>
                     <li>
                      <input
                        type="radio"
                        name="type"
                        onChange={handleChange}
                        value=""
                        checked={inputs.type === ""}
                      />
                      <label className="p-1">All</label>
                    </li>
                  </ul>}


   {inputs.type === "1" && !hideEmployeeTypeFilter && 
                  <div className="col-md-12">
                  <label className="mb-0"> Select Employee Type</label>

                  <ul className="customradio input-group d-flex gap-2  mb-4 px-0 mx-0">
                    {/* <li  >
                      <input
                        type="radio"
                        name="empType"
                        onChange={handleChange}
                        value="1"
                        checked={inputs.empType === "1"}
                      />
                      <label className="p-1">Accounts</label>
                    </li>
                    <li>
                      <input
                        type="radio"
                        name="empType"
                        onChange={handleChange}
                        value="2"
                        checked={inputs.empType === "2"}
                      />
                      <label className="p-1" >Billing </label>
                    </li>
                     */}
                    <li>
                      <input
                        type="radio"
                        name="empType"
                        onChange={handleChange}
                        value="3"
                        checked={inputs.empType === "3"}
                      />
                      <label className="p-1" >Doctor</label>
                    </li>

                    {/* <li>
                      <input
                        type="radio"
                        name="empType"
                        onChange={handleChange}
                        value="4"
                        checked={inputs.empType === "4"}
                      />
                      <label className="p-1" >Nurse</label>
                    </li>


                    <li>
                      <input
                        type="radio"
                        name="empType"
                        onChange={handleChange}
                        value="5"
                        checked={inputs.empType === "5"}
                      />
                      <label className="p-1" >Runner</label>
                    </li> */}
                  </ul>
                </div>
               }

<div className="row">
  <div className="mb-2 col-md-6">
                  <label className="form-label text-dark small" htmlFor="name">
                    Full Name 
                  </label>
                  <div className="input-group   input-sm">
                    <input
                      type="text"
                      id="name"
                      className="form-control small p-1"
                      name="name"
                      value={inputs.name}
                      onChange={handleChange}
                    />
                  </div>
                </div>
  <div className="mb-2 col-md-6">
                  <label className="form-label text-dark small" htmlFor="name">
                    Phone
                  </label>
                  <div className="input-group   input-sm">
                    <input
                      type="number"
                      id="phone"
                      className="form-control small p-1"
                      name="phone"
                      value={inputs.phone}
                      onChange={handleChange}
                    />
                  </div>
                </div>

  <div className="mb-2 col-md-6">
                  <label className="form-label text-dark small" htmlFor="name">
                    Pincode
                  </label>
                  <div className="input-group   input-sm">
                    <input
                      type="number"
                      id="pincode"
                      className="form-control small p-1"
                      name="pincode"
                      value={inputs.pincode}
                      onChange={handleChange}
                    />
                  </div>
                </div>

   <div className="mb-2 col-6  ">
                  <label className="form-label text-dark" htmlFor="email">
                    State  
                  </label>
                  <div className="input-group    input-sm">
                    <select
                      className="form-control p-1"
                      id="state"
                      name="state"
                      value={inputs.state}
                      onChange={handleChange}
                    >
                      <option selected value={''}>
                        {" "}
                        {loading ? "Loading..." : "Select State"}
                      </option>
                      {AllState && AllState.map((item) => (
                        <option key={item._id} value={item._id}>
                          {item.name}
                        </option>
                      ))}{" "}
                      ;
                    </select>
                  </div>
                </div>

                <div className="mb-2 col-6 ">
                  <label className="form-label text-dark" htmlFor="city">
                    City  
                  </label>
                  <div className="input-group    input-sm">
                    <select
                      className="form-control p-1"
                      id="city"
                      name="city"
                      value={inputs.city}
                      onChange={handleChange}
                    >
                      <option selected value={""}>
                        {" "}
                        {loading ? "Loading..." : "Select City"}
                      </option>
                      {filteredCities.map((city, index) => (
                        <option key={index} value={city}>
                          {city}
                        </option>
                      ))}{" "}
                      ;
                    </select>
                  </div>
                </div>


     <label className="mb-2 col-md-6" > <div className="small mb-2 "> Working Status </div>
                      <select
                        className={`form-control small p-1 select  ${Active === 'all' && 'bg-warning text-dark'}
                         ${Active === '1' && 'bg-success text-white'}
                          ${Active === '0' && 'bg-danger text-white'}
                          `}
                        value={Active}
                        onChange={(e) => {
                          setActive(e.target.value, 'all');
                         }}
                      >
                        <option value={'all'}>All</option>
                        <option value={1}>available</option>
                        <option value={0}>unavailable</option> 
                      </select>{" "}
                       
                    </label>
</div>


 <div className="mb-2 col-md-12">
                  <label className="form-label text-dark small" htmlFor="name">
                    Location
                  </label>
                  <div className="input-group   input-sm">
                    <input
                      type="text"
                      id="location"
                      className="form-control small p-1"
                      name="location"
                      value={inputs.location}
                      onChange={handleChange}
                    />
                  </div>
                </div>

<div className="col-12">
                     {/* Multi Select for Coverage */}
   <div className="mb-2 ">
        <label className="form-label text-dark" htmlFor="coverage">
         Staff category <span className="text-muted">(Multi Select)</span>
        </label>
        <div className="input-group input-sm">
          <select
            className="form-control"
            id="nurse"
            name="nurse"
         onChange={handleChange}
         selected={inputs.nurse}
         value={'null'}
            
          >
            <option value="null" selected>
              Select Staff Category
            </option>
            {Nurse.map((data, index) => (
              <option key={index} value={data._id}>
                {data.name}
              </option>
            ))}
          </select>
        </div>
        </div>
        <div className="mb-2">
  {Array.isArray(inputs.nurse) && inputs.nurse.length > 0 ? (
   inputs.nurse.map((departmentId, index) => {
      const department = Nurse.find(item => item._id === departmentId);  // Find the department by its ID
      return department ? (
        <span
          key={index}
          className="badge bg-primary me-1 w-auto"
          style={{ cursor: "pointer" }}
          onClick={() => removeNurse(departmentId)}
          title="Click to remove"
        >
          {department.name} ×  {/* Display the department title */}
        </span>
      ) : null;
    })
  ) : (
    <span className="text-muted">No Staff category selected.</span>
  )}
</div>
</div>
 


<div className="col-12 d-flex align-items-center gap-2 mt-3">
  <button className="btn btn-danger btn-sm w-100 " onClick={handleReset}>
                      {" "}
                      Reset
                    </button>

  <button className="btn btn-primary btn-sm w-100" onClick={handleSearch}>
                      {" "}
                      Apply
                    </button>
</div>


  </ul>
</div>


                 
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <div className="datatable-search">
                      <input
                        className="datatable-input"
                        type="text"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={handleSearchInputChange}
                      />
                    </div>
                    <button className="btn btn-primary" onClick={handleSearch}>
                      {" "}
                      Search
                    </button>
                  </div>
                </div>

                <table className="table table-flush"  style={{minHeight:'60vh'}} >
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>User Details</th>
                      <th>Profile</th>
                      <th>Location</th>
                      <th>Phone</th>
                      <th>Status</th>
                      <th>Verification</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody   >
                    {data.map((row) => (
                      <tr key={row._id}>
                        <td>
                          {row.userId ? row.userId : "NA"}
                        </td>
                        <td>
                            <p className="m-0 small">   
                                 <span className="bg-success small text-white px-3 py-1 rounded-pill">
                                   {row.type === 1 && 'Employee' || row.type === 2 && 'User' || row.type === 3 && 'Vendor' || row.type === 0 && 'Admin'}
                                   </span>

                              {row.available === 1 ?
 <span className="bg-success small text-white px-3 py-1 rounded-pill"> available </span> :
 <span className="bg-danger small text-white px-3 py-1 rounded-pill me-2"> Working </span>
 } 
        
         <br/>
                        <b>  Name : </b> {row.username}     </p> 
                           
                          <p className="m-0 small"><b>  Pincode : </b> {row.pincode}  
                             </p> 

                               <p  className="m-0 small" ><b>  Mobile : </b> {row.phone}  
                             </p> 
                             <p  className="m-0 small" ><b>  Address : </b> {row.address}  
                             </p> 
                           
                          <br/>
                        </td>
                         <td>
                      {row.profile ? <>
                      <img src={weburl+row.profile} width={80} height={80} style={{aspectRatio:'1/1'}} className="rounded-circle"/>
                      </> : 'NA' } 
                        </td>
                        <td> {row.location ? row.location : "NA"} </td>
                        <td> {row.phone} </td>
                        <td>
                          <select
                            style={{ width: "fit-content" }}
                            className={`form-control select small p-1 ${row.status == 0
                              ? "text-white btn-danger"
                              : "text-white btn-success"
                              }`}
                            value={row.status}
                            name="status"
                            onChange={handleStatusChange(row._id)}
                          >
                            <option value="1">Active</option>
                            <option value="0">Inactive </option>
                          </select>

                          <br />
                        </td>
                        <td>
                          <select
                            style={{ width: "fit-content" }}
                            className={`form-control small p-1 select ${row.verified === 0
                              ? "text-white btn-danger" // For row.verified === 0, apply text-white and btn-danger
                              : row.verified === 2
                                ? "text-white btn-warning" // For row.verified === 2, apply text-white and btn-warning
                                : "text-white btn-success" // For row.verified === 1 or any other value, apply text-white and btn-success
                              }`}
                            value={row.verified}
                            name="status"
                            onChange={handleVerifyChange(row._id)}
                          >
                            <option value="1">Verified</option>
                            <option value="2">Pending</option>
                            <option value="0">unverified </option>
                          </select>    
                    
                     
                        </td>
                        <td>
                          <Link
                            class="btn btn-secondary btn-sm mb-2"
                            to={`/user/${row._id}`}
                          >
                            View <i class="ri-user-fill"></i>
                          </Link>
                         <br/>
                           <Link
                            class="btn btn-secondary btn-sm"
                            to={`/user-edit/${row._id}`}
                          >
                            Edit <i class="ri-user-fill"></i>
                          </Link>
                         <br/>
                          <a
                            class="btn btn-secondary mt-2 btn-sm"
                            target="blank"
                            href={`${weburl}user-view/${row._id}`}
                          >
                            View Profile 
                          </a>
                            <br/>
                            {row.type !== 0 && 
                            <button
                            class="btn btn-danger mt-2 btn-sm"
                            target="blank"
                              onClick={() => handleDelete(row._id)}
                            >
                           Delete
                          </button>
                            }
                          
                        </td>
                      </tr>
                    ))}

 {data.length === 0 && (
  <tr style={{height:300}}  >
              <td  colSpan={100}  >
                <p className="d-inline-flex align-items-center justify-content-center w-100 h3 text-danger" style={{height:300}} >
                 No User Found 
                 
                   </p></td>
                   </tr>
            )}

           
                  </tbody>
                </table>

                <div className="datatable-bottom">
                  <div className="datatable-info"> </div>
                  <nav className="datatable-pagination">
                    <ul class="datatable-pagination-list">
                      <li
                        className={`datatable-pagination-list-item ${currentPage === 1
                          ? "datatable-hidden"
                          : "datatable-active"
                          }`}
                      >
                        <button
                          data-page="1"
                          class="datatable-pagination-list-item-link"
                          onClick={handlePreviousPage}
                          disabled={loading || currentPage === 1}
                          aria-label="Page 1"
                        >
                          ‹
                        </button>
                      </li>
                      <li>
                        <div className="datatable-info py-1 px-3">
                          Showing Page{" "}
                          <strong>
                            Showing Page {currentPage} of {totalPages}
                          </strong>{" "}
                        </div>
                      </li>
                      <li
                        className={`datatable-pagination-list-item ${currentPage === totalPages
                          ? "datatable-hidden"
                          : "datatable-active"
                          }`}
                      >
                        <button
                          data-page="2"
                          class="datatable-pagination-list-item-link"
                          aria-label="Page 2"
                          onClick={handleNextPage}
                          disabled={loading || currentPage === totalPages}
                        >
                          {" "}
                          {loading ? "Loading..." : "›"}{" "}
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </>
            )}
          </div>
        </div>
      </main>
    </>
  );
}

export default AllUser;
